import { OrderType, PayerType } from "@merchstores/shared/components/MerchStore";
import axios, { AxiosResponse } from "axios";

export interface IShopifyQueryCost {
  requestedQueryCost: number
  actualQueryCost: number,
  throttleStatus: {
      maximumAvailable: number,
      currentlyAvailable: number,
      restoreRate: number
  }
}

export interface IShopifyOrder {
  id: string;
  name: string;
  displayFulfillmentStatus: string;
  createdAt: string;
  closedAt: string;
  email: string;
  totalPrice: string;
  totalTax: string;
  totalShippingPrice: string;
  shippingTitle: string;
  tags: Array<string>;
  customer: {
    displayName: string;
    email: string;
  };
  itemsCount: number;
  lineItems?: Array<any>;
}

export interface IShopifyOrdersData {
  orders: Array<IShopifyOrder>;
  cursor: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export interface IShopifyOrdersResponse extends AxiosResponse {
  data: IShopifyOrdersData;
}

export interface IShopifyOrdersParams {
  storeCode: string;
  combinedOrderId?: string;
  orderType?: OrderType;
  payerType?: PayerType;
  closeDate?: string;
  sorting?: "dateDesc" | "dateAsc";
  cursor?: string | null;
}

export async function fetchShopifyOrders(
  params: IShopifyOrdersParams
): Promise<IShopifyOrdersData> {
  if (!params.storeCode) {
    throw new Error("storeCode parameter is required");
  }

  const response: IShopifyOrdersResponse = await axios
    .post("/.netlify/functions/fetchMerchStoreOrders", params)
    .catch((err) => {
      if (err.response && err.response.data) {
        console.error(err.response.data);
      }

      throw err;
    });

  return response.data;
}


export interface IFetchShopifyOrderParams {
  storeCode: string;
  orderId: string;
}

export interface IFetchShopifyOrderResponse {
  data: IShopifyFetchOrderData
}

export interface IShopifyFetchOrderData {
  order: IShopifyOrder,
  queryCost: IShopifyQueryCost
}

export async function fetchShopifyOrder(
  params: IFetchShopifyOrderParams
): Promise<IShopifyFetchOrderData> {
  if (!params.storeCode) {
    throw new Error("storeCode parameter is required");
  }

  const response: IFetchShopifyOrderResponse = await axios
    .post("/.netlify/functions/fetchMerchStoreOrderById", params)
    .catch((err) => {
      if (err.response && err.response.data) {
        console.error(err.response.data);
      }

      throw err;
    });

  return response.data;
}